import { Affix } from "antd";
import React from "react";
import {
  Col,
  FormGroup,
  FormLabel,
  ListGroup,
  ListGroupItem,
  Row,
  Tab,
  Tabs
} from "react-bootstrap";
import { labels } from "../../../../../../localization/labels";
import ComponentHeader from "../../../../../core/ComponentHeader/ComponentHeader";
import DropDown from "../../../../../core/DropDown";
import SubmitButton from "../../../../../core/SubmitButton";
import SubmitControl from "../../../../../core/SubmitControl";

const constructLifeCycles = (title, lifecycles, onClick, itemVariant) => (
  <Col sm="6">
    <div>
      <Row>
        <Col>
          <FormLabel className="Label">{title}</FormLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <ListGroup className="bordered-overflow-select-box">
            {lifecycles.map(lifeCycle => (
              <ListGroupItem
                as={"a"}
                onClick={() => onClick(lifeCycle)}
                variant={itemVariant}
              >
                {lifeCycle.name}
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
      </Row>
    </div>
  </Col>
);

const constructNextLifeCycles = (
  lifeCycle,
  posibleNextLifeCycles,
  onNextLifeCycleClick,
  onPosibleNextLifeCycleClick
) => {
  if (!(lifeCycle && lifeCycle.nextLifeCycles && posibleNextLifeCycles)) {
    return undefined;
  }
  return (
    <>
      <Row>
        {constructLifeCycles(
          labels.possibleNextStates,
          posibleNextLifeCycles,
          onPosibleNextLifeCycleClick,
          "danger"
        )}
        {constructLifeCycles(
          labels.selectedNextStates,
          lifeCycle.nextLifeCycles,
          onNextLifeCycleClick,
          "success"
        )}
      </Row>
    </>
  );
};

const LifeCycle = props => {
  const lifeCycle = props.lifeCycle;
  const nextLifeCycles = constructNextLifeCycles(
    lifeCycle,
    props.posibleNextLifeCycles,
    props.onNextLifeCycleClick,
    props.onPosibleNextLifeCycleClick
  );

  return (
    <>
      <div className="container">
        <ComponentHeader
          title={labels.lifeCycle}
          id={lifeCycle.id}
          showBackButton
        />
        <div className="bordered_bottom_rounded">
          <br></br>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.name}</FormLabel>
            </Col>
            <Col>
              <FormGroup controlId="name">
                <SubmitControl
                  autoFocus
                  type="text"
                  title={labels.name}
                  value={lifeCycle.name}
                  onChange={props.onChange}
                  placeholder={labels.name}
                  validationRule={props.validationRules.name}
                />
              </FormGroup>
            </Col>
          </Row>
          <Tabs>
            <Tab
              eventKey="additionalData"
              title={labels.additionalData}
              className="Tab"
            >
              <Row>
                <Col sm="2">
                  <FormLabel className="Label">{labels.dateFromTo}</FormLabel>
                </Col>
                <Col sm="10">
                  <FormGroup controlId="dateFromTo">
                    <SubmitControl
                      type="dateRange"
                      placeholder={[
                        labels.dateFromPlaceholder,
                        labels.dateToPlaceholder
                      ]}
                      validationRule={
                        props.validationRules &&
                        props.validationRules.dateFromTo
                      }
                      value={lifeCycle.dateFromTo}
                      onChange={props.onChange}
                      controlId={"dateFromTo"}
                      disabled={props.disabledInitialState}
                    ></SubmitControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel className="Label">
                    {labels.lifeCycleStateType}
                  </FormLabel>
                </Col>
                <Col sm="10">
                  <FormGroup controlId="lifeCycleStateType">
                    <DropDown
                      disabled={props.disabledInitialState}
                      value={
                        lifeCycle.lifeCycleStateType &&
                        lifeCycle.lifeCycleStateType.id
                          ? lifeCycle.lifeCycleStateType
                          : undefined
                      }
                      options={props.lifeCycleStateTypes.map(x => ({
                        value: x,
                        label: x.name
                      }))}
                      onChange={props.onChange}
                      targetId={"lifeCycleStateType"}
                      required={
                        props.validationRules["lifeCycleStateType.id"] &&
                        props.validationRules["lifeCycleStateType.id"].required
                      }
                      placeholder={labels.lifeCycles}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="lifeCycleTransitions"
              title={labels.lifeCycleTransitions}
              className="Tab"
            >
              {nextLifeCycles}
            </Tab>
          </Tabs>
          <Affix offsetBottom={true}>
            <div className="bottom_bar">
              <SubmitButton
                type="save"
                onClick={props.onSave}
                disabled={props.disabled}
              />
            </div>
          </Affix>
        </div>
      </div>
    </>
  );
};

export default LifeCycle;
